/**
 * react-router-config.js 同
 * https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
 *
 * @Author: jruif
 * @Date: 2018/2/4 下午3:03
 */
import React, { Fragment } from 'react';
import { Switch, Redirect, matchPath, Router } from 'react-router';
import { Route } from 'react-router-dom';
import deepCopy from 'deep-extend';
import LoadPageAnimate from './LoadPageAnimate';
import extend from 'object-assign';
// containers
import NotFound from 'Main/errorPage/404';

const RenderRoute = ({
  component: Component,
  docTitle,
  subtitle,
  routes = [], // 子路由
  map = [],
  className = '',
  other,
  routerDidSwitch,
  animateName,
  controlAccess,
  location,
  ...rest
}) => (
  <Route
    {...rest}
    location={location}
    render={props => (
      <LoadPageAnimate
        switchPath={rest.path}
        docTitle={docTitle}
        className={className}
        routerDidSwitch={routerDidSwitch}
        animateName={animateName}>
        <Component
          {...props}
          {...other}
          routes={routes}
          renderChildRouters={({ location }) => {
            return routes.length > 0
              ? createRoutes(
                  {
                    routes: routes.map(item => extend({}, item, { path: rest.path + item.path })), // todo: 加和路由存在bug
                    location,
                    routerDidSwitch,
                    controlAccess,
                    ...other,
                  },
                  true,
                )
              : null;
          }}
        />
      </LoadPageAnimate>
    )}
  />
);

const { computeMatch } = Router.prototype;
const matchRoutes = (routes, pathname, /*not public API*/ branch = []) => {
  routes.some(route => {
    const match = route.path
      ? matchPath(pathname, route)
      : branch.length
      ? branch[branch.length - 1].match // use parent match
      : computeMatch(pathname); // use default "root" match

    if (match) {
      branch.push({ route, match });

      if (route.routes) {
        matchRoutes(route.routes, pathname, branch);
      }
    }

    return match;
  });

  return branch;
};

const createRoutes = (
  { routes, location, routerDidSwitch, controlAccess, match, redirectUrl = '/lead', ...other },
  isChildRouter = false,
) => {
  const branch = matchRoutes(routes, location.pathname);
  const route = branch.length > 0 ? branch[branch.length - 1].route : null;
  let hasAccess = true;
  // 权限控制
  if (controlAccess && route !== null) {
    hasAccess = controlAccess(route);
  }
  return (
    <Switch>
      <Route
        exact
        path="/"
        render={routeProps => <Redirect to={deepCopy({}, routeProps.location, { pathname: '/index' })} />}
      />
      <RenderRoute path="/lead" component={NotFound} docTitle="网易号" />
      {route && hasAccess ? (
        <RenderRoute
          {...route}
          map={branch.map(item => item.route)}
          routerDidSwitch={routerDidSwitch}
          controlAccess={controlAccess}
          location={location}
          other={other}
        />
      ) : isChildRouter ? null : (
        <Redirect to={typeof redirectUrl === 'function' ? redirectUrl(route) : redirectUrl} />
      )}
    </Switch>
  );
};

export default createRoutes;
export { RenderRoute, matchRoutes };
